export default "__VITE_ASSET__D09mC1jX__"